import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { debounceTime, map, tap, withLatestFrom } from "rxjs";
import { findTreeNode } from "src/app/utilities/tree";
import { RootState } from "../root-state.model";
import * as TreeActions from './actions';
import { selectObjectTreeErrors, selectTree } from "./selects";

@Injectable()
export class ObjectTreeEffects {
  constructor(
    private actions$: Actions,
    private store: Store<RootState>
  ) { }


  // on items selection change: set/remove MultipleCatalogs-Error
  selectedItemsChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TreeActions.SetSelectedItems),
      withLatestFrom(this.store.select(selectObjectTreeErrors)),
      debounceTime(0),
      tap(([action, errs]) => {
        const selectedCatalogIds = [...new Set(action.items.map(i => i.item.catalogId))]
        if (selectedCatalogIds.length > 1 && (!errs || !errs['MultipleCatalogs']))
          this.store.dispatch(TreeActions.SetTreeErrors({ errors: { MultipleCatalogs: true } }))
        else if (selectedCatalogIds.length <= 1 && errs && errs['MultipleCatalogs'])
          this.store.dispatch(TreeActions.SetTreeErrors({ errors: null }))
      })
    ),
    { dispatch: false }
  )


  setSelectedItemIds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TreeActions.SetSelectedItemIds),
      withLatestFrom(this.store.select(selectTree)),
      map(([action, tree]) => {
        const items = action.items
          .map((id, i) => {
            const item = findTreeNode(tree!, id);
            if (!item) {
              console.warn(`Item ${id} not found in tree`, tree)
              return null
            }

            return { ...item, colorNr: i + 1 }
          })
          .filter(i => !!i)

        return TreeActions.SetSelectedItems({ items })
      })
    )
  )
}
